export function stagedRevision(data) {
  const { stagedRevisionId, playbookId, pipelineVars, readyForDeploy, stagedForDelete } = data;
  return {
    staged_revision: {
      on_conflict: {
        constraint: 'pipeline_vars_pkey',
        update_columns: ['playbookId', 'pipelineVars', 'readyForDeploy', 'stagedForDelete'],
      },
      data: {
        id: stagedRevisionId,
        playbookId,
        pipelineVars,
        readyForDeploy,
        stagedForDelete,
      },
    },
  };
}
